module.exports = __webpack_public_path__ + "static/media/18_plantilla_rec_combo_simple_cp_stills_tetra_200_ades_frutas_trop.4e229243.png";